module.exports = __webpack_public_path__ + "img/picto-admin.b96b38f4.svg";